<po-page-list
  p-title="Carregamentos ME"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
  [p-actions]="pageActions">
  <po-table class="po-md-12"
    p-container="shadow"
    p-height="550"
    [p-items]="tabelaPrincipalItems"
    [p-columns]="tabelaPrincipalColumns"
    [p-actions]="tabelaPrincipalActions"
    [p-filter-type]="poSearchFilterMode"
    p-hide-columns-manager="true"
    p-hide-table-search="false"
    p-striped="true">
  </po-table>
</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" p-size="sm" [p-primary-action]="advancedFilterPrimaryAction">
  <form #formFiltroPrincipal="ngForm">
    <po-datepicker class="po-md-6"
      name="DZ07DATINC_DE"
      p-label="Data Inclusão De"
      [(ngModel)]="filtroPrincipal.dados.DZ07DATINC_DE"
      [p-iso-format]="formatExtended">
    </po-datepicker>
    <po-datepicker class="po-md-6"
      name="DZ07DATINC_ATE"
      p-label="Data Inclusão Até"
      [(ngModel)]="filtroPrincipal.dados.DZ07DATINC_ATE"
      [p-iso-format]="formatExtended">
    </po-datepicker>
    <po-input class="po-md-6"
      name="CZ07CODIGO"
      p-label="Código"
      p-maxlength="6"
      [(ngModel)]="filtroPrincipal.dados.CZ07CODIGO">
    </po-input>
    <po-select class="po-md-6"
      name="CZ07STATUS"
      p-label="Status"
      [(ngModel)]="filtroPrincipal.dados.CZ07STATUS"
      [p-options]="optionsStatusCarregamento">
    </po-select>
  </form>
</po-modal>
